<template>
  <div class="main-promo">
    <div class="main-promo__content">
      <h1 class="main-promo__title">
        Платформа для&nbsp;общения, работы и&nbsp;обучения онлайн
        с&nbsp;поддержкой&nbsp;ИИ
      </h1>
      <p class="main-promo__description">
        От видеозвонков и&nbsp;мессенджера до&nbsp;конференций на&nbsp;тысячи
        зрителей и&nbsp;онлайн-досок для&nbsp;команд
      </p>
      <div class="main-promo__buttons">
        <VButtonLinkMTSV2
          href="/user/organizer/"
          class="--violet-gradient --l"
        >
          <span>попробовать бесплатно</span>
        </VButtonLinkMTSV2>
        <VButtonLinkMTSV2 href="/user/demo/" class="--black --l">
          <span>оставить заявку</span>
        </VButtonLinkMTSV2>
      </div>
    </div>
    <div class="main-promo__products">
      <MainPromoProductListDesktop class="main-promo__products--desktop" />
      <MainPromoProductListMobile class="main-promo__products--mobile" />
    </div>
  </div>
</template>

<script>
import VButtonLinkMTSV2 from '@/components/Common/MTS/VButtonLinkMTSV2.vue'
import MainPromoProductListDesktop from '@/components/NewDesign/Page/Index/Parts/Promo/ProductList/MainPromoProductListDesktop.vue'
import MainPromoProductListMobile from '@/components/NewDesign/Page/Index/Parts/Promo/ProductList/MainPromoProductListMobile.vue'

export default {
  name: 'MainPromo',
  components: {
    MainPromoProductListMobile,
    MainPromoProductListDesktop,
    VButtonLinkMTSV2,
  },
}
</script>

<style scoped lang="scss">
.main-promo {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 64px;
  font-family: $font-mts-compact;

  @include screen-up('md') {
    text-align: center;
    background: url("@/assets/new-design/img/index/promo/promo-bg--1920.webp") no-repeat center;
    background-size: cover;
  }

  @include screen-down('lg') {
    padding-bottom: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1035px;
    height: 100%;
    padding: 64px 32px;
    margin: 0 auto;

    @include screen-down('lg') {
      padding: 64px 32px 32px;
      background: url("@/assets/new-design/img/index/promo/promo-bg--991.webp") no-repeat center;
      background-size: cover;
    }

    @include screen-between('md', 'lg') {
      min-height: 448px;
    }

    @include screen-down('md') {
      align-items: stretch;
      padding: 64px 20px 32px;
      background: url("@/assets/new-design/img/index/promo/promo-bg--768.webp") no-repeat center;
      background-size: cover;
    }
  }

  &__products {
    padding: 32px 0;

    @include screen-down('lg') {
      width: 100%;
      padding: 32px 12px;
      background-color: $color-white;
    }

    @include screen-down('md') {
      padding: 32px 0;
    }

    &--desktop {
      @include screen-down('lg') {
        display: none;
      }
    }

    &--mobile {
      @include screen-up('lg') {
        display: none;
      }
    }
  }

  &__title {
    font-size: 56px;
    line-height: 61px;
    font-weight: 500;
    color: $color-dark-2;

    @include screen-down('lg') {
      font-size: 52px;
      line-height: 60px;
    }

    @include screen-down('md') {
      font-size: 32px;
      line-height: 36px;
    }
  }

  &__description {
    max-width: 754px;
    margin-top: 16px;
    font-size: 24px;
    line-height: 32px;
    color: $color-gray-1;

    @include screen-down('lg') {
      max-width: 628px;
      font-size: 20px;
      line-height: 28px;
    }
  }

  &__buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding-top: 64px;
    margin-top: auto;

    @include screen-up('md') {
      max-width: 546px;
    }

    @include screen-down('md') {
      grid-template-columns: 1fr;
      gap: 12px;
      padding-top: 32px;
    }
  }
}
</style>
